import React, { useState } from 'react';
import Timekeeper from 'react-timekeeper';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import './timePicker.css'

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import Error from '../error';

const Tooltip = asyncRoute(() => import('../ToolTip'));

const index = (props) => {
  const {
    onChange, onBlur = () => { }, value, submited, touched, error, coarseMinutes = 1, hour24Mode = false, forceCoarseMinutes = false,
    setting: { key, label, placeholder, displayLayout, labelLayout = 'col-sm-4', required, tooltip },
  } = props;

  // ---* React Hook  State Create *----
  const [showTime, setShowTime] = useState(false);

  // ----* Time Picker Modal Show * -----
  const timePickerShow = () => (
    <div>
      <div className="timepicker-backdrop"></div>
      <Timekeeper
        forceCoarseMinutes={forceCoarseMinutes}
        coarseMinutes={coarseMinutes}
        time={value ? value : undefined}
        onChange={({ formatted12 }) => {
          let event = { target: { name: key, value: formatted12 } };
          onChange(event);
        }}
        onDoneClick={({ formatted12 }) => {
          let event = { target: { name: key, value: formatted12 } };
          setShowTime(false);
          onBlur(event);
        }}
        switchToMinuteOnHourSelect
        hour24Mode={hour24Mode}
      />
    </div>);

  return (
    <>
      {showTime && timePickerShow()}
      <div className="form-group row d-flex justify-content-center">
        {label && <label htmlFor={key} className={`${labelLayout} col-form-label`}>{label}{' '} {required && <span className="arterisk"> * </span>}</label>}
        <div className={displayLayout}>
          <div className="input-group">
            <input
              type={'text'}
              // defaultValue={value}
              value={value}
              name={key}
              disabled={true}
              className={isEmpty(error) ? "form-control" : "form-control has-error"}
              placeholder={placeholder}
            />
            <span className="input-group-append" role="right-icon">
              {/* <i onClick={()=>{
                let event = { target: { name: key, value: '' } };
                onChange(event);
              }} className="mdi mdi-close-circle-outline close-icon"></i> */}
              <button
                onClick={() => setShowTime(true)}
                className="btn btn-outline-secondary border-left-0 zindex"
                type="button"
              >
                <i className="mdi mdi-clock-outline time-icon"></i>
              </button>
            </span>
          </div>
          {(submited || touched) && (<Error setting={props.setting} error={error} />)}
        </div>
        {tooltip && <Tooltip text={tooltip} />}
      </div>
    </>
  )
}
export default index;

// ---* time Picker Prop Types *---
index.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  coarseMinutes: PropTypes.number,
  hour24Mode: PropTypes.bool,

  // -----* setting PropTypes *----
  setting: PropTypes.shape({
    required: PropTypes.bool,
    label: PropTypes.string,
    key: PropTypes.string,
    placeholder: PropTypes.string,
    tooltip: PropTypes.string,
    touched: PropTypes.object
  }),
}